module.exports = __webpack_public_path__ + "static/media/home1.543bad55.png";